import React from 'react';

const StakingContext = React.createContext({
  wallet: {},
  provider: {},
  validNetwork: true,
  loadWeb3Modal: () => {},
  logoutOfWeb3Modal: () => {},
});

export default StakingContext;
